module.exports = __webpack_public_path__ + "static/media/pierre-4.2b6ab87e.jpeg";